import storageFilters from '@/store/modules/storage-filter'
import {isEqual} from 'lodash'

const oldLocalStorageVuexFilters: any = localStorage.getItem('vuex-filters')
const oldVuexFilters = oldLocalStorageVuexFilters ?
  JSON.parse(oldLocalStorageVuexFilters).storageFilter : null
const {local: {state: local}, session: {state: session}} = storageFilters.modules || {}
const newVuexFilters = {local, session}
const isEqualFilters = oldVuexFilters ? isEqual(oldVuexFilters, newVuexFilters) : true

const initVuexFilters = () => {
  if(!isEqualFilters) {
    localStorage.removeItem('vuex-filters')
  }
}

export {oldVuexFilters, newVuexFilters, isEqualFilters, initVuexFilters}
